<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">增加数量<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入增加数量" v-model="addObj.num">
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">
            类型<span>*</span>
          </p>
          <div class="write-text">
            <el-radio-group v-model="addObj.type" @change="typeChange">
              <el-radio label="1">会员</el-radio>
              <el-radio label="2">积分</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-txt" v-if="addObj.type == 2">
          <p class="write-title">输入积分额度<span>*</span></p>
          <div class="write-text">
            <input type="number" placeholder="请输入积分额度" v-model="addObj.credits">
          </div>
        </div>
        <div class="write-txt" v-if="addObj.type == 2">
            <p class="write-title">
              积分有效期<span>*</span>
            </p>
            <div class="write-text">
              <input type="number" v-model="addObj.credits_time" class="vip_time">
              <el-radio-group v-model="vip_date">
                <el-radio label="d">天</el-radio>
                <el-radio label="m">月</el-radio>
                <el-radio label="y">年</el-radio>
              </el-radio-group>
            </div>
          </div>
        <div class="write-txt" v-else>
          <p class="write-title">选择类型<span>*</span></p>
          <div class="write-text">
            <el-select v-model="addObj.vip_id" placeholder="请选择">
              <el-option
                v-for="item in codeList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span>最多输入30个中/英、数字和特殊符号</span>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加核销码</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.key}}</p>
              <p :title="item.verify_code">{{item.verify_code}}</p>
              <p :title="item.status==0?'未使用':'已使用'">{{item.status==0?'未使用':'已使用'}}</p>
              <p :title="item.type==1?'会员':'积分'">{{item.type==1?'会员':'积分'}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addVerifyCode,getVerifyCodeList,getVipIphoneList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'12',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'兑换码'},
        {id:3,title:'状态'},
        {id:4,title:'类型'},
        {id:5,title:'添加时间'},
      ],
      dataList:[
      ],
      addType:'',
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        num:'',
        type:'1',
      },
      totalPage:0,
      typelist:[
        {id:1,title:'中文'},
        {id:2,title:'英文'},
      ],
      codeList:[],
      removeType:false,
      vip_date:'d'
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getVerifyCodeList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
      try {
        const response = await getVipIphoneList({type:2},this.token);
        if(response.code == 200){
          that.codeList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.num == ''){
        that.$message('请输入数量！');
        return false;
      }
      if(this.addObj.type == 1){
        if(!this.addObj.vip_id){
          that.$message('请选择会员类型！');
          return false;
        }
      } else {
        if(this.addObj.credits == ''){
          that.$message('请填写积分额度！');
          return false;
        }
        if(this.addObj.credits_time == ''){
          that.$message('请填写积分有效期！');
          return false;
        }
        this.addObj.credits_time = this.addObj.credits_time + this.vip_date;
      }
      try {
        const response = await addVerifyCode(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        num:'',
        type:'1',
      }
    },

    typeChange(){
      if(this.addObj.type == 1){
        this.addObj = {
          num:'',
          type:'1',
        }
      } else {
        this.addObj = {
          num:'',
          type:'2',
          credits:'',
          credits_time:''
        }
      }
    }
    
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 5 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .write-txt>>> .el-radio__label{
    font-size: 18px;
    vertical-align: top;
  }

  .write-txt>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
    line-height: 45px;
  }

  .MobelBox input.vip_time{
    display:inline-block;
    width: 120px;
    padding: 0 10px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/code/list.vue